export default {
  id: 18,
  pride: 36864,
  slug: "bedtime-stories-with-ai",
  category: "tool",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "与AI的睡前故事",
    en: "Bedtime Stories with AI"
  },
  image: require('@/assets/images/bedtime_stories.webp'),
  descriptionKey: {
    zh: "一个适合小说作者/剧本/人机恋爱好者的deepseek大模型客户端",
    en: "A Deepseek LLM client for novel writers, screenplay authors, and human-AI relationship enthusiasts"
  },
  date: { year: 2025, month: 2 },
  genres: ["AI工具", "写作辅助"],
  themes: ["人机交互", "故事创作"],
  engine: "Web",
  platform: ["Web"],
  achievements: [
    { zh: "几百人使用过", en: "Used by hundreds of people" }
  ],
  developerNotesKey: {
    zh: "LLM客户端网页工具，自用，小火一阵子，几百人使用过了，被朋友评价为这应该收钱我还给人免费用。",
    en: "LLM client web tool, for personal use. Got somewhat popular for a while, used by hundreds of people. Friends commented that I should charge for this instead of giving it away for free."
  },
  tags: ["LLM"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "web", url: "https://ai.tobenot.top/", textKey: { zh: "在线使用", en: "Use Online" } }
  ],
  promoUrl: 'https://tobenot.top/pr/bedtime-stories/'
};
